import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid, Stack } from '@mui/material';
import { FormContainer, SwitchElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { BaseSettingsFormProps } from '../../hooks/useSocialExportFactory';
import { FormSection } from '../../screens/manage/platforms/FormSection';

export const facebookSettingsSchema = z.object({
  private: z.boolean().optional(),
});

export function FacebookSettingsForm({
  stationId,
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.FacebookSettingsDto>) {
  const { $t } = useIntl();
  return (
    <FormContainer
      mode="onBlur"
      values={{
        private: defaultSettings?.private ?? true,
      }}
      onSuccess={async (formData) => {
        await onUpdate({
          private: formData.private,
        });
      }}
      resolver={zodResolver(facebookSettingsSchema)}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.defaultValuesUploads',
          defaultMessage: 'Valores por defecto para uploads',
        })}
      >
        <Grid container>
          <Grid item md={4}>
            <Stack spacing={2}>
              <SwitchElement
                name="private"
                label={$t({
                  id: 'socialExport.form.uploadAsPrivate',
                  defaultMessage: 'Cargar como video privado',
                })}
                color="primary"
              />
            </Stack>
          </Grid>
        </Grid>
      </FormSection>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
